
<template>
  <div>
    <div class="content-fixed">
      <p class="content-title">{{data.detailsText.title}}</p>

      <div>
        <p class="content-warn">{{data.detailsText.warn}}</p>
        <p class="content-content">{{data.detailsText.content}}</p>
        <div class="content-icon" alt="下划线" />
      </div>
    </div>

    <div class="content-scroll">
      <div class="content-scroll-wrapper" v-for="item in data.detailsText.illustrate" :key="item.id">
        <p class="content-scroll-illustrate">{{item.illustrateContent}}</p>
      </div>
      <p class="content-scroll-warn">{{data.detailsText.illustrateWarn}}</p>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: ['data']
}
</script>

<style lang="scss" scoped>

.content-title {
  position: relative;
  margin: 0 auto 34px;
  line-height: 38px;
  font-size: 22px; font-weight: 500;
  color: #000000;
  font-family: Alibaba-PuHuiTi-Heavy;

  &::after {
    content: " ";
    position: absolute; top: 43px; left: 50%; right: -20px;
    width: 40px; height: 5px;
    background: #DE3640;
    transform: translateX(-50%);
  }

  @include mobile {
    font-size: 16px;
    line-height: 22px;
  }
}

.content-warn {
  margin-bottom: 20px;
  color: #828A92;
  line-height: 20px;
  font-size: 14px; font-weight: 400;

  @include mobile {
    font-size: 12px;
  }
}

.content-content {
  margin-bottom: 20px;
  color: #000000;
  line-height: 28px;
  text-align: left;
  font-size: 16px; font-weight: 500;

  @include mobile {
    font-size: 13px;
    line-height: 24px;
  }
}

.content-icon {
  width: 100%; height: 2px;
  margin: 0 auto 20px;
  background: url('https://static001.geekbang.org/resource/image/d3/99/d326ce14aa4e3a59f741a60300d2af99.png') center / cover no-repeat;
}

.content-scroll {
  height: 300px;
  text-align: left;
  overflow-y: scroll;

  @include mobile {
    height: 216px;
  }
}

.content-scroll-wrapper {
  margin-bottom: 20px;
}

.content-scroll-illustrate {
  color: #000000;
  line-height: 35px;
  font-size: 16px; font-weight: 400;

  @include mobile {
    font-size: 12px;
    line-height: 24px;
  }
}

.content-scroll-warn {
  color: #828A92;
  line-height: 28px;
  text-align: center;
  font-size: 14px; font-weight: 400;

  @include mobile {
    font-size: 12px;
    line-height: 20px;
  }
}

// 默认出现滚动条
.content-scroll::-webkit-scrollbar {
 -webkit-appearance: none;
 }

 .content-scroll::-webkit-scrollbar:vertical {
   width: 7px;
 }

 .content-scroll::-webkit-scrollbar:horizontal {
   height: 0.06rem;
 }

.content-scroll::-webkit-scrollbar-thumb {
  // border: 2px solid white; /* should match background, can't be transparent */
  background-color: #d8d8d8;
  border-radius: 5px;
}

</style>
